import { USER_ROLES, UserPermissions } from '../constants/constants'

export const hasPermissionCheck = (
    userPermissions: UserPermissions[],
    required: UserPermissions | UserPermissions[],
): boolean => {
    if (!required) return false

    if (Array.isArray(required)) {
        return required.some((perm) => userPermissions.includes(perm))
    }

    return userPermissions.includes(required)
}

/**
 * Who may make, edit, set the default of and delete templates: Org Admin
 * (`user:admin`) and Super Admin (`organization:admin`) for every entity, and
 * for a Device entity also the Device Manager role. Others still see the list
 * and use the templates, read-only.
 */
export const canManageTemplates = ({
    permissions,
    userRole,
    isDeviceTemplate,
}: {
    permissions: UserPermissions[] | undefined
    userRole: string
    isDeviceTemplate: boolean
}): boolean => {
    const isOrgOrSuperAdmin =
        hasPermissionCheck(permissions ?? [], [
            UserPermissions.USER_ADMIN,
            UserPermissions.ORG_ADMIN,
        ]) || userRole === USER_ROLES.SYSTEM_ADMIN
    return (
        isOrgOrSuperAdmin ||
        (isDeviceTemplate && userRole === USER_ROLES.DEVICE_MANAGER)
    )
}
